/*namespace Serenity {
    @Decorators.registerEditor("Serenity.DateYearEditor")
    export class DateYearEditor extends SelectEditor {
        constructor(hidden: JQuery, opt: DateYearEditorOptions) {
            super(hidden, opt);

            this.updateItems();
        }

        // get value(): string {
        //     return this.get_value();
        // }

        // set value(v: string) {
        //     this.set_value(v);
        // }

        getItems() {
            var opt = this.options as DateYearEditorOptions;

            if (opt.items && opt.items.length) {
                return opt.items;
            }

            let minYear,
                maxYear;

            /* if (Q.Culture.name !== "english" && $.calendars) {
                minYear = maxYear = $.calendars.instance(Q.Culture.name).today().year();
            } else { #1#
                minYear = maxYear = new Date().getFullYear();
            /* } #1#

            let years = [];

            opt.minYear = `${Q.coalesce(opt.minYear, "-10").toString()}`;

            if (Q.startsWith(opt.minYear, "-")) {
                minYear -= parseInt(opt.minYear.substr(1), 10);
            } else if (Q.startsWith(opt.minYear, "+")) {
                minYear += parseInt(opt.minYear.substr(1), 10);
            } else {
                minYear = parseInt(opt.minYear, 10);
            }

            opt.maxYear = `${Q.coalesce(opt.maxYear, "+10")}`;

            if (Q.startsWith(opt.maxYear, "-")) {
                maxYear -= parseInt(opt.maxYear.substr(1), 10);
            } else if (Q.startsWith(opt.maxYear, "+")) {
                maxYear += parseInt(opt.maxYear.substr(1), 10);
            } else {
                maxYear = parseInt(opt.maxYear, 10);
            }

            if (opt.descending) {
                for (var i = maxYear; i >= minYear; i--) {
                    years.push(i.toString());
                }
            } else {
                for (var i1 = minYear; i1 <= maxYear; i1++) {
                    years.push(i1.toString());
                }
            }

            return years;
        }

        // get_value(): string {
        //     let value = this.element.val().trim();
        //
        //     if (!value) {
        //         return null;
        //     }
        //
        //     return Q.formatDate(value,"yyyy");
        // }

        // set_value(value: string) {
        //     debugger;
        // }
    }

    export interface DateYearEditorOptions extends SelectEditorOptions {
        minYear?: string;
        maxYear?: string;
        descending?: boolean;
    }
}*/